define.alias("ember-math-helpers/helpers/mult", "media/helpers/mult");